import { createSingleAction } from 'store/utils';

const SET_SHEET_APPROVAL_LOADING_STATE = 'sheets_approval/SET_LOADING_STATE';
type SetSheetApprovalLoadingStateActionConst = typeof SET_SHEET_APPROVAL_LOADING_STATE;
export const setSheetApprovalLoadingState = createSingleAction<boolean, SetSheetApprovalLoadingStateActionConst>(
    SET_SHEET_APPROVAL_LOADING_STATE,
);
